import React from 'react';
import { Stack } from '@efast_public/fjd-component-library';
import { Link } from 'react-router-dom';
import { RoutePaths } from '../AppRoutes';

const EmptySchreibtischNoTabs = () => {
  return (
    <React.Fragment>
      <Stack direction="row" spacing="xs">
        <div>
          Bitte öffnen Sie einen oder mehrere Anträge über die Antragsübersicht.
        </div>
        <Link id={'link-antragsuebersicht'} to={RoutePaths.ANTRAEGE}>
          Zur Antragsübersicht
        </Link>
      </Stack>
    </React.Fragment>
  );
};

export default EmptySchreibtischNoTabs;
